module.exports = __webpack_public_path__ + "static/img/powered.3efca28.png";


//////////////////
// WEBPACK FOOTER
// ./static/client/powered.png
// module id = MLMZ
// module chunks = 1